import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AreaMap } from 'src/app/domain/GS/area-map';
import { MeasureReference } from 'src/app/domain/GS/measure-reference';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { AreaMapService } from 'src/app/services/GS/area-map.service';
import { MeasureReferenceService } from 'src/app/services/GS/measure-reference.service';
import { CoreData } from '../../core-data/core-data';
import * as _ from 'lodash'
import { EStrategyType } from 'src/app/domain/strategy-type';
import { EMeasureReferenceType } from 'src/app/domain/enum/measure-reference-type';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-complementary-box',
    templateUrl: './complementary-measure-box.html',
    styleUrls: ['./complementary-measure-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ComplementaryMeasurenBoxDialog extends BaseComponent implements OnInit {
    EStrategyType = EStrategyType;
    private strategyId: number;
    strategyType: number;
    Model: ClientMeasure = new ClientMeasure();
    MeasureCount: number = 1;
    // ExoticMeasureList: string[] = Object.values(EExoticMeasure).filter(x => !isNaN(Number(x))).map(x => StringConverter.getExoticMeasure(x as EExoticMeasure));
    AreaMapList: AreaMap[] = [];
    MeasureReferenceList: MeasureReference[] = [];
    SelectedMeasureReference: MeasureReference;

    constructor(
        protected coreData: CoreData,
        private areaMapService: AreaMapService,
        private measureReferenceService: MeasureReferenceService,
        public dialogRef: MatDialogRef<ComplementaryMeasurenBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {
        super(coreData);
        this.strategyId = data.strategyId;
        this.strategyType = data.strategyType;
    }

    ngOnInit() {
        this.getAreaMapList();
        this.getMeasureReferenceList();
    }

    getAreaMapList() {
        this.areaMapService.getAreaMapFromStrategy(this.strategyId).subscribe(x => {
            this.AreaMapList = x;
        })
    }

    getMeasureReferenceList() {
        this.measureReferenceService.getAllMeasureReferences().subscribe(x => {
            if (this.strategyType === EStrategyType.FDX)
                this.MeasureReferenceList = x.filter(x => x.Type === EMeasureReferenceType.FDX || x.Type === EMeasureReferenceType.HorsFDX)
            else
                this.MeasureReferenceList = x.filter(x => x.Type === EMeasureReferenceType.Gax || x.Type === EMeasureReferenceType.None)

            // if (!this.IsDispatch)
            //     this.MeasureReferenceList = this.MeasureReferenceList.filter(x => x.Type === EMeasureReferenceType.HorsFDX || x.Type === EMeasureReferenceType.None)

            if (this.IsDispatch) { // DISPATCH
                this.MeasureReferenceList = this.MeasureReferenceList.filter(x =>
                    x.Code !== "HGMesureAdductionAir" &&
                    x.Code !== "HGMesureEau" &&
                    x.Code !== "HGMesureLingette" &&
                    x.Code !== "HGMesureMassif" &&
                    x.Code !== "HFMesureAdductionAir" &&
                    x.Code !== "HFMesureEau" &&
                    x.Code !== "HFMesureLingette" &&
                    x.Code !== "HFMesureMassif")
            } else { // CLIENT
                this.MeasureReferenceList = this.MeasureReferenceList.filter(x =>
                (x.Code === 'K' ||
                    x.Code === 'L' ||
                    x.Code === 'M' ||
                    x.Code === 'N' ||
                    x.Code === 'O' ||
                    x.Code === 'P' ||
                    x.Code === 'Q' ||
                    x.Code === 'R' ||
                    x.Code === 'S' ||
                    x.Code === 'HGEMPAV' ||
                    x.Code === 'HGM DÉCHETS' ||
                    x.Code === 'HGEMPPT' ||
                    x.Code === 'HGEMPAP' ||
                    x.Code === 'HGEMAM' ||
                    x.Code === 'HGEMP' ||
                    x.Code === 'AC' ||
                    x.Code === 'ZT' ||
                    x.Code === 'EPP' ||
                    x.Code === 'EC' ||
                    x.Code === 'ZRE' ||
                    x.Code === 'VAP ' ||
                    x.Code === 'ZR ' ||
                    x.Code === 'VUMD ' ||
                    x.Code === 'ZAMD' ||
                    x.Code === 'VAP' ||
                    x.Code === 'ZR' ||
                    x.Code === 'VUMD' ||
                    x.Code === 'HFEMAV' ||
                    x.Code === 'HFM DÉCHETS' ||
                    x.Code === 'HFEMPPT' ||
                    x.Code === 'HFEMPAP' ||
                    x.Code === 'HFEMAM' ||
                    x.Code === 'HFEMP' ||
                    x.Code === 'Annexe B')
                )
            }

        })
    }

    private IsMeasureOnOperator(code: string) {
        if (code === 'AC' || code === 'SEPTP1' || code === 'SEPTP2' || code === 'CNEPE' || code === 'CNEPV' || code === 'CNEPO' || code === 'CEJT' || code === 'SEDFP' || code === 'SPRMPC' || // FDX
            code === 'I' || code === 'Je' || code === 'Jv' || code === 'K') // GAX
            return true;
        return false;
    }

    CanAdd() {
        if (this.MeasureCount < 1)
            return false;
        if (this.IsDispatch)
            return this.SelectedMeasureReference && this.IsMeasureOnOperator(this.SelectedMeasureReference.Code) ? true : this.Model.AreaMapName !== undefined;
        return this.SelectedMeasureReference;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {

        if (!this.CanAdd())
            return;

        let list: ClientMeasure[] = [];
        // Array.from(Array(this.MeasureCount)).forEach((x: ClientMeasure) => {
        for (let i = 0; i < this.MeasureCount; i++) {

            let x = new ClientMeasure();
            x = Object.assign(x, this.Model)
            x.MeasureReferenceCode = this.SelectedMeasureReference.Code
            x.MeasureReferenceName = this.SelectedMeasureReference.Name;
            list.push(x);
        }
        // })

        this.dialogRef.close(list);
    }
}
